import React from 'react';
import { Box } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';

export interface ISearchDropdownItem {
  label: string;
  value: string;
}

export type ISearchDropdwon = ISearchDropdownItem[];

export interface ISearchDropdwonProps {
  options: ISearchDropdwon;
  value?: ISearchDropdownItem | null;
  // eslint-disable-next-line no-unused-vars
  onChange?: (value: ISearchDropdownItem | null) => void;
  useFirstAsDefault?: boolean;
}
export function DropdownSearch({
  options,
  value,
  onChange,
  useFirstAsDefault = true,
}: ISearchDropdwonProps) {
  const defaultValue = useFirstAsDefault && options.length > 0 ? options[0] : undefined;
  return (
    <Box minW={{ base: '100%', md: '180px' }} maxW={{ base: '100%', md: '180px' }}>
      <Select
        placeholder="Buscar por"
        options={options}
        value={value ?? defaultValue}
        onChange={onChange}
        isSearchable
        size="md"
        chakraStyles={{
          control: provided => ({
            ...provided,
            minHeight: '40px',
            height: '40px',
          }),
          valueContainer: provided => ({
            ...provided,
            height: '40px',
            padding: '0 8px',
          }),
          input: provided => ({
            ...provided,
            margin: '0',
            padding: '0',
          }),
          indicatorsContainer: provided => ({
            ...provided,
            height: '40px',
          }),
        }}
      />
    </Box>
  );
}
